import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="single-select-toggle"
export default class extends Controller {
  static targets = ["item", "nav", "hiddenValue"]

  connect() {
  }

  toggle(event) {
    // Update hidden value field if present (e.g. search_tab)
    if (this.hasHiddenValueTarget) {
      this.hiddenValueTarget.value = event.currentTarget.dataset.itemName;
    }

    for (var i = 0; i < this.itemTargets.length; i++) {
      this.itemTargets[i].classList.add("hidden")
      this.navTargets[i].classList.remove("active-nav")
      this.navTargets[i].classList.add("inactive-nav")

      if (this.itemTargets[i].dataset.itemName == event.currentTarget.dataset.itemName) {
        this.itemTargets[i].classList.remove("hidden")
        this.navTargets[i].classList.remove("inactive-nav")
        this.navTargets[i].classList.add("active-nav")
      } else {
        const inputElements = this.itemTargets[i].querySelectorAll('input, select, textarea');
        inputElements.forEach(input => {
          if (input.type === 'checkbox' || input.type === 'radio') {
            input.checked = false;
          } else if (input.tagName.toLowerCase() === 'select') {
            input.selectedIndex = -1;
          } else {
            input.value = "";
          }
        });
        this.itemTargets[i]
      }
    }
  }

}
